module.exports = "<a ng-href=\"{{ $ctrl.storeUrl }}\">\r\n    <img class=\"app-store-badge\" ng-src=\"{{ $ctrl.storeBadge }}\" />\r\n</a>";